import React from "react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const restaurants = [{
  name: "Toro Latin Kitchen",
  dish: "Smoked Guacamole & Corn Empanadas",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1557866/img/culinary_dish_toro.png"
}, {
  name: "Guard and Grace",
  dish: "Oak Fired Octopus with Chorizo",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1557866/img/culinary_dish_guard.png"
}, {
  name: "Tamayo",
  dish: "Tacos de Canasta & Mole Poblano",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1557866/img/culinary_dish_tamayo.png"
}, {
  name: "El Five",
  dish: "Paella de Mariscos",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1557866/img/culinary_dish_elfive.png"
}, {
  name: "Santo",
  dish: "Blue Corn Posole",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1557866/img/culinary_dish_santo.png"
}, {
  name: "Mister Oso",
  dish: "Coconut Rice & Mojo Pork",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1557866/img/culinary_dish_misteroso.png"
}, {
  name: "Perdida",
  dish: "Wood-Fired Baja Sea Bass",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1557866/img/culinary_dish_perdida.png"
}, {
  name: "Kachina Cantina",
  dish: "Fry Bread Tacos",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1557866/img/culinary_dish_kachina.png"
}];
export default function CulinaryCuration() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="culinary-curation" ref={ref} className="dark bg-background text-foreground py-24 lg:py-32 relative overflow-hidden">
      <div className="container mx-auto px-6 lg:px-8 mb-16 text-center">
        <h2 className={cn("text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-primary mb-6 transition-all duration-700 transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
          Culinary Curation
        </h2>
        <p className={cn("text-lg md:text-xl font-sans text-muted-foreground max-w-2xl mx-auto transition-all duration-700 delay-100 transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
          Experience an exclusive tasting journey featuring Colorado's most
          celebrated chefs and multicultural kitchens.
        </p>
      </div>

      <div className="w-full max-w-[1920px] mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-0">
          {restaurants.map((item, i) => <div key={i} data-index={i} className={cn("group relative overflow-hidden cursor-pointer transition-all duration-700", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-20")} style={{
          transitionDelay: `${i * 100}ms`
        }}>
              <AspectRatio ratio={1}>
                <img src={item.image} alt={`${item.name} - ${item.dish}`} className="object-cover w-full h-full transition-transform duration-700 group-hover:scale-110" />
                {}
                <div className="absolute inset-0 bg-gradient-to-t from-[var(--color-chart-3)]/95 to-[var(--color-chart-4)]/90 translate-y-full group-hover:translate-y-0 transition-transform duration-500 ease-out flex flex-col justify-end p-8 text-white">
                  <div className="transform translate-y-4 group-hover:translate-y-0 transition-transform duration-500 delay-100">
                    <h3 className="text-2xl font-serif font-bold mb-2 leading-tight">
                      {item.name}
                    </h3>
                    <div className="h-0.5 w-12 bg-white/50 mb-3" />
                    <p className="text-sm md:text-base font-sans font-medium tracking-wide opacity-90">
                      {item.dish}
                    </p>
                  </div>
                </div>
              </AspectRatio>
            </div>)}
        </div>
      </div>
    </section>;
}